import React from "react"

import AdminDrawer from "../../components/AdminDrawer"
import ScoutObservabilityComponent from "../../components/ScoutObservability"

const ScoutObservability = () => {
    return (
        <AdminDrawer child={<ScoutObservabilityComponent />} />
    )
}

export default ScoutObservability
